import CentralStore from "../../pages/CentralStore"
import ProductList from "../../pages/CentralStore/productList"
import RequestedList from "../../pages/CentralStore/requestList"
import ReqView from "../../pages/CentralStore/requestList/view"
import RequestProduct from "../../pages/CentralStore/requestProduct"
import StoreList from "../../pages/CentralStore/storeList"
import StoreProductView from "../../pages/CentralStore/storeList/view"
import StockTransferHistory from "../../pages/CentralStore/transferHistory"
import SiteProductList from "../../pages/SiteStore"

export const centalStoreRoutes = [
  { path: "/central-store", component: <CentralStore /> },
  { path: "/central-store/store-list", component: <StoreList /> },
  { path: "/central-store/store-list/:id", component: <StoreProductView /> },
  { path: "/procurement/product-list", component: <ProductList /> },
  { path: "/procurement/request-product", component: <RequestProduct /> },
  { path: "/central-store/requested-list", component: <RequestedList /> },
  { path: "/central-store/requested-list/:id", component: <ReqView /> },
  { path: "/procurement/stock-transfer-history", component: <StockTransferHistory /> },
  { path: "/site-store/product-list", component: <SiteProductList /> },
]
